"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapDispatchToProps = exports.mapStateToProps = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var recompose_1 = require("recompose");
var membersActions = require("@caddigital/sok-reducers/lib/actions/customer/members");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var toastActions = require("@caddigital/sok-reducers/lib/actions/toast");
var GenericInviteModal_1 = require("components/modals/GenericInviteModal");
var types_1 = require("types");
var mapStateToProps = function (_a) {
    var customer = _a.customer;
    return {
        isOpen: customer.members.invite.isOpen,
        status: customer.members.invite.status,
        inviteRows: customer.members.invite.inviteRows,
        items: customer.members.groups,
        errors: customer.members.invite.errors,
        groupsStatus: customer.members.status
    };
};
exports.mapStateToProps = mapStateToProps;
var mapDispatchToProps = function (dispatch) { return ({
    toggleModal: function () { return dispatch(membersActions.UsergroupInvite.clear()); },
    selectItem: function (uuid, itemId) {
        return dispatch(membersActions.UsergroupInvite.inviteSelectItem(uuid, itemId));
    },
    addNewRow: function (item) {
        return dispatch(membersActions.UsergroupInvite.addRow(item.uuid, item.group, item.emails, item.language));
    },
    removeRow: function (uuid) {
        return dispatch(membersActions.UsergroupInvite.removeRow(uuid));
    },
    addNewToast: function (title, message, type) {
        return dispatch(toastActions.addNewToast(title, message, type));
    },
    updateEmails: function (uuid) { return function (email) {
        return dispatch(membersActions.UsergroupInvite.updateEmails(uuid, email));
    }; },
    updateLanguage: function (uuid, language) {
        return dispatch(membersActions.UsergroupInvite.UpdateLanguage(uuid, language));
    },
    sendInvitations: function (props) { return function () {
        return props.customerId !== null &&
            dispatch(membersActions.UsergroupInvite.inviteRequest(props.inviteRows, [
                membersActions.UsergroupList.fetchRequest('CUSTOMER_MEMBERS', props.customerId)
            ]));
    }; }
}); };
exports.mapDispatchToProps = mapDispatchToProps;
//#region Types
var statePropsExtractable = (0, types_1.extractReturnType)(exports.mapStateToProps);
var dispatchPropsExtractable = (0, types_1.extractReturnType)(exports.mapDispatchToProps);
//#endregion
var enhance = (0, recompose_1.compose)((0, react_redux_1.connect)(exports.mapStateToProps, exports.mapDispatchToProps), recompose_1.pure);
exports.default = enhance(function (props) {
    var message = (React.createElement(React.Fragment, null,
        React.createElement("li", null,
            " ", "".concat((0, translation_1.getLocalization)('invite/member/info')),
            " "),
        React.createElement("li", null,
            " ", "".concat((0, translation_1.getLocalization)('invite/member/info/second')),
            " "),
        React.createElement("li", null,
            " ", "".concat((0, translation_1.getLocalization)('invite/member/info/third')),
            " ")));
    return (React.createElement(GenericInviteModal_1.default, { isOpen: props.isOpen, modalTitle: (0, translation_1.getLocalization)('invite/member'), message: message, status: props.status, inviteRows: props.inviteRows, items: props.items.map(function (x) { return x.category; }), toggleModal: props.toggleModal, selectItem: props.selectItem, updateEmails: props.updateEmails, updateLanguage: props.updateLanguage, addNewRow: props.addNewRow, inviteText: (0, translation_1.getLocalization)('components/modals/genericInvitationModal/invite'), addNewToast: props.addNewToast, sendInvitations: props.sendInvitations(props), errors: props.errors, groupStatus: props.groupsStatus, removeRow: props.removeRow }));
});
